import React from 'react';
import { Hero } from '../components/home/Hero';
import { FeaturedProtocols } from '../components/home/FeaturedProtocols';
import { Transparency } from '../components/home/Transparency';
import { PriceComparison } from '../components/home/PriceComparison';
import { ShopPreview } from '../components/home/ShopPreview';
import { Steps } from '../components/home/Steps';
import { LabsPreview } from '../components/home/LabsPreview';
import { Values } from '../components/home/Values';
import { Testimonial } from '../components/home/Testimonial';
import { SectionHeading } from '../components/ui/SectionHeading';
import { FaqList } from '../components/ui/FaqList';
import { CtaBand } from '../components/ui/CtaBand';
import { faqs } from '../data/site';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import { useBrand } from '../contexts/BrandContext';
export function Home() {
  const {
    brand
  } = useBrand();
  useDocumentMeta({
    title: brand.copy.metaTitle,
    description: brand.copy.metaDescription,
    image: brand.images.hero
  });
  return <main data-id="element-441" data-mp="30up1g32jsgdz">
      <Hero data-id="element-442" data-mp="30uf9i9xxzz5n" />
      <FeaturedProtocols data-id="element-443" data-mp="2vxyault4a2eb" />
      <Transparency data-id="element-444" data-mp="2vxf13sdmekbd" />
      <PriceComparison data-id="element-445" data-mp="2vy82sexq2jmn" />
      <ShopPreview data-id="element-446" data-mp="2vvltoav6nw2b" />
      <Steps data-id="element-447" data-mp="2qylrwc5d9fh0" />
      <LabsPreview data-id="element-448" data-mp="2qy2glea81pby" />
      <Values data-id="element-449" data-mp="2qxkfa38pckx6" />
      <Testimonial data-id="element-450" data-mp="2qx0vsi3eloh1" />

      <section className="bg-cream-light" data-id="element-451" data-mp="2r0oo5dx444u6">
        <div className="mx-auto max-w-shell px-6 py-16 md:px-8 md:py-24" data-id="element-452" data-mp="2mxs21d8d5qlh">
          <div className="grid gap-8 lg:grid-cols-[0.8fr_1.2fr] lg:gap-20" data-id="element-453" data-mp="2hxxdhgc29d3l">
            <SectionHeading eyebrow="FAQ" title="The questions people actually ask." data-id="element-454" data-mp="2i00bamjggaiv" />
            <FaqList items={faqs} data-id="element-455" data-mp="2d5w3y26a20h9" />
          </div>
        </div>
      </section>

      <CtaBand data-id="element-456" data-mp="288vxvr9fgxq5" />
    </main>;
}